<template>
  <div>
    <h4>
      Tipos de contrato habilitados
    </h4>
    <v-radio-group
      :value="value"
      @change="handleUpdateContractType"
      row
      hide-details
    >
      <v-radio :value="CONTRACT_TYPE.sale" label="Venta"> </v-radio>
      <v-radio :value="CONTRACT_TYPE.rent" label="Renta"> </v-radio>
      <v-radio :value="CONTRACT_TYPE.both" label="Ambos"> </v-radio>
    </v-radio-group>
  </div>
</template>
<script>
import { CONTRACT_TYPE } from "../property/const";

export default {
  name: "EditContractType",
  props: { value: { type: String, default: CONTRACT_TYPE.sale } },
  data() {
    return { CONTRACT_TYPE };
  },
  methods: {
    handleUpdateContractType(contract_type) {
      this.$emit("change", contract_type);
    }
  }
};
</script>
